// c360 list — saf filtre/OData yardımcıları (UI bağımsız).
// Kaynak: CustomersPage.js (jenerikleştirildi).

export const FILTER_OPERATORS = {
  text: [
    { id: 'contains', label: 'İçerir', needsValue: true },
    { id: 'notContains', label: 'İçermez', needsValue: true },
    { id: 'equals', label: 'Eşittir', needsValue: true },
    { id: 'notEquals', label: 'Eşit değil', needsValue: true },
    { id: 'startsWith', label: 'Başlar', needsValue: true },
    { id: 'endsWith', label: 'Biter', needsValue: true },
    { id: 'blank', label: 'Boş', needsValue: false },
    { id: 'notBlank', label: 'Dolu', needsValue: false },
  ],
  number: [
    { id: 'equals', label: 'Eşittir', needsValue: true },
    { id: 'notEquals', label: 'Eşit değil', needsValue: true },
    { id: 'gt', label: 'Büyüktür (>)', needsValue: true },
    { id: 'gte', label: 'Büyük eşit (≥)', needsValue: true },
    { id: 'lt', label: 'Küçüktür (<)', needsValue: true },
    { id: 'lte', label: 'Küçük eşit (≤)', needsValue: true },
    { id: 'between', label: 'Arasında', needsValue: true, needsValue2: true },
    { id: 'blank', label: 'Boş', needsValue: false },
    { id: 'notBlank', label: 'Dolu', needsValue: false },
  ],
  date: [
    { id: 'equals', label: 'Tarih eşit', needsValue: true },
    { id: 'before', label: 'Önce', needsValue: true },
    { id: 'after', label: 'Sonra', needsValue: true },
    { id: 'between', label: 'Arasında', needsValue: true, needsValue2: true },
    { id: 'blank', label: 'Boş', needsValue: false },
    { id: 'notBlank', label: 'Dolu', needsValue: false },
  ],
  select: [
    { id: 'equals', label: 'Eşittir', needsValue: true },
  ],
};
// asyncSelect, select ile aynı operatör setini kullanır (sunucu-arama UI farkı).
FILTER_OPERATORS.asyncSelect = FILTER_OPERATORS.select;

export const DEFAULT_OP = { text: 'contains', number: 'equals', date: 'equals', select: 'equals', asyncSelect: 'equals' };

export function getOperator(type, opId) {
  const list = FILTER_OPERATORS[type] || [];
  return list.find((o) => o.id === opId) || list[0];
}

export function escapeODataString(value) {
  return String(value).replace(/'/g, "''");
}

export function buildFilterClause(meta, filter) {
  if (!filter || !meta) return null;

  // ── Kaçış kapısı: `field op value` kalıbına SIĞMAYAN filtreler (örn. alt koleksiyon üzerinde
  //    lambda: `ReturnDetails/any(d: d/ProductId eq <guid>)`). Meta bir `buildClause(filter)`
  //    verirse cümleyi O üretir. Opt-in: mevcut sayfaların hiçbiri etkilenmez.
  if (typeof meta.buildClause === 'function') return meta.buildClause(filter) || null;

  const { odataField, type } = meta;
  const op = getOperator(type, filter.op);
  const value = filter.value;
  const value2 = filter.value2;

  if (op.id === 'blank') {
    return type === 'text' ? `(${odataField} eq null or ${odataField} eq '')` : `${odataField} eq null`;
  }
  if (op.id === 'notBlank') {
    return type === 'text' ? `(${odataField} ne null and ${odataField} ne '')` : `${odataField} ne null`;
  }

  if (op.needsValue && (value === undefined || value === null || value === '')) return null;
  if (op.needsValue2 && (value2 === undefined || value2 === null || value2 === '')) return null;

  if (type === 'text') {
    const q = escapeODataString(value).toLowerCase();
    if (op.id === 'contains') return `contains(tolower(${odataField}),'${q}')`;
    if (op.id === 'notContains') return `not contains(tolower(${odataField}),'${q}')`;
    if (op.id === 'startsWith') return `startswith(tolower(${odataField}),'${q}')`;
    if (op.id === 'endsWith') return `endswith(tolower(${odataField}),'${q}')`;
    if (op.id === 'equals') return `tolower(${odataField}) eq '${q}'`;
    if (op.id === 'notEquals') return `tolower(${odataField}) ne '${q}'`;
  }

  if (type === 'number') {
    const n = Number(value);
    if (op.id === 'equals') return `${odataField} eq ${n}`;
    if (op.id === 'notEquals') return `${odataField} ne ${n}`;
    if (op.id === 'gt') return `${odataField} gt ${n}`;
    if (op.id === 'gte') return `${odataField} ge ${n}`;
    if (op.id === 'lt') return `${odataField} lt ${n}`;
    if (op.id === 'lte') return `${odataField} le ${n}`;
    if (op.id === 'between') return `(${odataField} ge ${n} and ${odataField} le ${Number(value2)})`;
  }

  if (type === 'date') {
    if (op.id === 'equals') return `${odataField} eq ${value}`;
    if (op.id === 'before') return `${odataField} lt ${value}`;
    if (op.id === 'after') return `${odataField} gt ${value}`;
    if (op.id === 'between') return `(${odataField} ge ${value} and ${odataField} le ${value2})`;
  }

  if (type === 'select' || type === 'asyncSelect') {
    if (meta.valueFormat === 'guid') return `${odataField} eq ${value}`;
    // 'raw': değeri tırnaksız bas (boolean true/false vb. için → `IsRequired eq true`)
    if (meta.valueFormat === 'raw') return `${odataField} eq ${value}`;
    if (meta.valueFormat === 'string') return `${odataField} eq '${escapeODataString(value)}'`;
    const numeric = Number(value);
    if (Number.isFinite(numeric) && String(numeric) === String(value)) return `${odataField} eq ${numeric}`;
    return `${odataField} eq '${escapeODataString(value)}'`;
  }

  return null;
}

export function unwrapLookupItems(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.Data)) return payload.Data;
  if (Array.isArray(payload?.value)) return payload.value;
  return [];
}

export function toInt(value) {
  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * c360 liste $select alanlarını üretir — Column Chooser ile entegre.
 *
 * Yalnız GÖRÜNÜR kolonların OData kaynak alanlarını (`columnFilterMeta[colId].odataField`)
 * + `always` (varsayılan ['Id']: satır anahtarı + görüntüle/değiştir/sil navigasyonu)
 * + `sortField` döndürür. `needsFullData` (grup/kanban/chart/export) ise `null` → tüm entity.
 *
 * DİKKAT: $select, client'ın row'dan okuduğu HER alanı içermeli — hücrede/gruplama/renk/nav'da
 * kolon-dışı okunan alanlar varsa `always`'e ekle, yoksa o alan undefined gelir (sessiz kırılma).
 * Hesaplanan kolonlar (accessorFn) kaynak FK'yı okur → columnFilterMeta odataField'i onu vermeli
 * (ör. groupLabel→GroupId). Emin değilsen selectFields'i hiç verme (tüm entity = güvenli fallback).
 *
 * Sonuç STABİL olmalı: useMemo([needsFullData, columnVisibility, sortField, ...]) ile sar.
 */
export function buildSelectFields({ columnFilterMeta, columnVisibility = {}, sortField, always = ['Id'], needsFullData = false }) {
  if (needsFullData) return null;
  const set = new Set(always);
  for (const [colId, meta] of Object.entries(columnFilterMeta || {})) {
    if (meta && meta.odataField && columnVisibility[colId] !== false) set.add(meta.odataField);
  }
  if (sortField) set.add(sortField);
  return Array.from(set);
}
